import {React} from '@api'
import {Tooltip as MaterialTooltip} from '@material-ui/core'
import {Kbd} from '~components/Kbd'
import * as css from './Tooltip.css'

/* -------------------------------------------------- */
/*                       Tooltip                      */

/* -------------------------------------------------- */

interface TooltipProps {
  children: React.ReactElement<any, any>
  label: string
  kbd?: string
  side?: 'bottom' | 'left' | 'right' | 'top'
}

export function Tooltip({
  children,
  label,
  kbd: kbdProp,
  side = 'top'
}: TooltipProps): JSX.Element {
  return (
    <MaterialTooltip
      classes={{tooltip: css.tooltip}}
      title={<div className={css.content} dir='ltr' data-side={side} data-offset={8}>
        {label}
        {kbdProp ? <Kbd variant='tooltip'>{kbdProp}</Kbd> : null}
      </div>}>
      <div className={css.childrenWrapper}>
      {children}
      </div>
    </MaterialTooltip>
  )
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/Tooltip/Tooltip.tsx